import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { ClienteTipoLCTCDTO, ClienteSubTipoLCTCDTO, RelacionLCTCViewDTO, RelacionLCTCItemDTO } from './types'

const getEndpoint = (url = '') => `operacion-lctc${url}`

export const HttpClienteTipoLCTC = {
    getAll: (): Promise<ClienteTipoLCTCDTO[]> =>
        HttpAxiosRequest.get(getEndpoint('/cliente-tipo')),

    insert: (data: { vchDescClienteTipo: string }): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint('/cliente-tipo'), { descripcion: data.vchDescClienteTipo }),

    update: (id: number, data: { vchDescClienteTipo: string }): Promise<any> =>
        HttpAxiosRequest.put(getEndpoint(`/cliente-tipo/${id}`), { descripcion: data.vchDescClienteTipo }),

    deactivate: (id: number): Promise<any> =>
        HttpAxiosRequest.delete(getEndpoint(`/cliente-tipo/${id}`))
}

export const HttpClienteSubTipoLCTC = {
    getAll: (): Promise<ClienteSubTipoLCTCDTO[]> =>
        HttpAxiosRequest.get(getEndpoint('/cliente-subtipo')),

    insert: (data: { vchDescClienteSubTipo: string }): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint('/cliente-subtipo'), { descripcion: data.vchDescClienteSubTipo }),

    update: (id: number, data: { vchDescClienteSubTipo: string }): Promise<any> =>
        HttpAxiosRequest.put(getEndpoint(`/cliente-subtipo/${id}`), { descripcion: data.vchDescClienteSubTipo }),

    deactivate: (id: number): Promise<any> =>
        HttpAxiosRequest.delete(getEndpoint(`/cliente-subtipo/${id}`))
}

export const HttpLCTCRelacion = {
    getBySector: (codSectorComercial: number): Promise<RelacionLCTCViewDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/relacion/${codSectorComercial}`)),

    update: (codSectorComercial: number, relaciones: RelacionLCTCItemDTO[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/relacion/${codSectorComercial}`), relaciones)
}
